import React from "react";
import SidebarNavIcon from "../ui/SidebarNavIcon";

const PredictFilterRow = ({
  label,
  hint,
  active,
  onClick,
  icon,
  logo,
  rank,
  urgent,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`floor-row${active ? " floor-row-selected" : ""}`}
    aria-pressed={active}
    title={hint ? `${label} — ${hint}` : label}
  >
    <span
      className="floor-row-heat"
      style={{ "--heat": active ? "100%" : urgent ? "40%" : "12%" }}
      aria-hidden
    />
    <span className="floor-row-rank" aria-hidden>
      {rank != null ? String(rank).padStart(2, "0") : "·"}
    </span>
    {logo ? (
      <span className="floor-row-avatar floor-row-avatar-logo">
        <img src={logo} alt="" />
      </span>
    ) : (
      <span className="floor-row-avatar floor-row-avatar-icon">
        <SidebarNavIcon icon={icon} size={13} />
      </span>
    )}
    <span className="floor-row-body">
      <span className="floor-row-top">
        <span className="floor-row-name">{label}</span>
        {urgent && !active ? (
          <span className="floor-row-tags">
            <span className="floor-row-tag floor-row-tag-soon">Live</span>
          </span>
        ) : null}
      </span>
      {hint ? <span className="floor-row-match">{hint}</span> : null}
    </span>
  </button>
);

export default PredictFilterRow;
